import { render, staticRenderFns } from "./saleProduct.vue?vue&type=template&id=ad9b8ec6"
import script from "./saleProduct.vue?vue&type=script&lang=js"
export * from "./saleProduct.vue?vue&type=script&lang=js"
import style0 from "./saleProduct.vue?vue&type=style&index=0&id=ad9b8ec6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports